export { BaselineComponent } from './baseline.component';
export { remediate as Remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-gb/entra/identity/authentication/concept-authentication-authenticator-app';
